import React from 'react';
import classNames from 'classnames';
import { Attachment } from 'lib/components/Attachment';
import { metaKeyDisplay } from 'lib/helpers';

export function AttachmentBlock({ blockProps }) {
	const { entityData, onRemove } = blockProps;
	const { name, url } = entityData;
	return (
		<Attachment
			name={name}
			url={url}
			title={`按住 ${metaKeyDisplay} 点击打开附件连接`}
			onClick={evt => {
				evt.preventDefault();
				if (evt.metaKey || evt.ctrlKey) {
					window.open(url, '_blank');
				}
			}}
		/>
	);
}



// WEBPACK FOOTER //
// ./lib/editor/DraftEditor/plugins/fileImportPlugin/component/AttachmentBlock.jsx